import { css } from "styled-components"

const PostContentStyleOriginal = css`
  /* common setting */
  .custom-block {
    margin: 60px 0 30px;
    padding: 20px 25px;
    border-radius: 5px;
  }

  .custom-block-heading {
    position: relative;
    font-size: 1.2em;
    font-weight: 600;
    line-height: 1.2em;
    ::before {
      position: absolute;
      display: inline-block;
      top: 0;
      left: 0;
      font-size: 1.2em;
    }
  }

  .custom-block-body {
    margin: 10px 0 0;
    p {
      margin: 0;
      font-size: 0.95em;
    }
  }

  // emphasis 
  .emphasis {
    background: ${({ theme }) => theme.emphasis.background};
    .custom-block-body {
      margin: 0;
      p {
        color: ${({ theme }) => theme.emphasis.text};
      }
    }
  }

  // danger
  .danger {
    background: ${({ theme }) => theme.error.background};
    .custom-block-heading {
      color: ${({ theme }) => theme.error.mark};
    }
    .custom-block-body {
      p {
        color: ${({ theme }) => theme.error.text};
      }
    }
  }

  // info
  .info {
    background: ${({ theme }) => theme.warning.background};
    .custom-block-heading {
      color: ${({ theme }) => theme.warning.mark};
    }
    .custom-block-body {
      p {
        color: ${({ theme }) => theme.warning.text};
      }
    }
  }

  // matome
  .matome {
    background: ${({ theme }) => theme.info.background};
    .custom-block-heading {
      color: ${({ theme }) => theme.info.mark};
    }
    .custom-block-body {
      ul {
        margin: 10px !important;
        li {
          color: ${({ theme }) => theme.info.text};
          ::marker {
            color: ${({ theme }) => theme.info.mark};
          }
        }
      }
    }
  }

  // merit
  .merit {
    .custom-block-heading {
      display: inline-block;
      padding: 10px 15px;
      background: ${({ theme }) => theme.info.background};
      color: ${({ theme }) => theme.info.mark};
    }
    .custom-block-body {
      ul {
        margin: 15px 10px 0;
        li {
          margin: 10px;
          padding-left: 10px;
          color: ${({ theme }) => theme.info.text};
          ::marker {
            color: ${({ theme }) => theme.info.mark};
            content: "✔";
          }
        }
      }
    }
  }

  // demerit
  .demerit {
    .custom-block-heading {
      display: inline-block;
      padding: 10px 15px;
      background: ${({ theme }) => theme.error.background};
      color: ${({ theme }) => theme.error.mark};
    }
    .custom-block-body {
      ul {
        margin: 15px 10px 0;
        li {
          margin: 10px;
          padding-left: 10px;
          color: ${({ theme }) => theme.error.text};
          ::marker {
            color: ${({ theme }) => theme.error.mark};
            content: "✔︎";
          }
        }
      }
    }
  }

  // quote
  .quote {
    background: ${({ theme }) => theme.blockquote.background};
    .custom-block-heading {
      color: #FFB26B;
      font-size: 1em;
      font-weight: 400;
    }
    .custom-block-body {
      p {
        color: ${({ theme }) => theme.blockquote.text};
      }
    }
  }

  // recommend
  .recommend {
    .custom-block-heading {
      display: inline-block;
      padding: 10px 15px;
      background: ${({ theme }) => theme.info.background};
      color: ${({ theme }) => theme.info.mark};
    }
    .custom-block-body {
      margin: 0;
      ul {
        margin: 0;
        background: ${({ theme }) => theme.info.background};
        li {
          margin:  0 15px 10px;
          padding: 15px 10px;
          ::marker {
            color: ${({ theme }) => theme.info.mark};
            content: "✔︎";
          }
        }
      }
    }
  }
`

export default PostContentStyleOriginal